import type React from 'react';
import { Flex } from '@timeedit/ui-components/antd';
import './FieldChangedMark.scss';

interface FieldChangedMarkProps {
  value: any;
  changed?: boolean;
}

const FieldChangedMark: React.FC<FieldChangedMarkProps> = ({
  value,
  changed = true,
}) => {
  return (
    <Flex align="center" className="field-changed-container">
      <span
        className={[
          'field-changed-mark-circle',
          changed ? '' : 'field-changed-mark-hidden',
        ].join(' ')}
      />
      <>{value}</>
    </Flex>
  );
};

export default FieldChangedMark;
